import { APIServices } from './axiosCommon';

export interface AdminMember {
  uid: number;
  username: string | null;
  email: string | null;
  firstname: string | null;
  lastname: string | null;
  verified: number;
  tfstaff: boolean;
  accessLevel: number;
  lastLoggedIn: string | null;
  dateRegistered: string | null;
  roles: { id: number; name: string }[];
}

export interface AdminRole {
  id: number;
  name: string;
  description: string | null;
  isSystem: boolean;
}

export interface UpdateMemberInput {
  verified?: number;
  tfstaff?: boolean;
  accessLevel?: number;
  roleIds?: number[];
}

export interface AdminMachine {
  uid: number;
  id: string | null;
  machineType: string;
  locationId: number | null;
  locationName: string | null;
  heatpads: boolean;
  cleanCamera: boolean;
  weightCapacityKG: number | null;
  bottomVesselToShaftCM: number | null;
  shaftToProbeTopCM: number | null;
  lastImport: string | null;
  subscriberCount: number;
}

export interface UpdateMachineInput {
  machineType?: 'composter' | 'lifter';
  weightCapacityKG?: number | null;
  bottomVesselToShaftCM?: number | null;
  shaftToProbeTopCM?: number | null;
  heatpads?: boolean;
  cleanCamera?: boolean;
}

export interface SensorSnapshot {
  machineUid: number;
  machineId: string | null;
  machineType: string;
  latestInsight: {
    ts: string | null;
    totesLoaded: number;
    kgsLoaded: number;
    pileTemp: number | null;
    avgMoisture: number | null;
  } | null;
  latestAsync: {
    timestampUtc: string | null;
    machineStatus: number | null;
    pileLevelCm: number | null;
    loadCellKg: number | null;
  } | null;
}

export const adminApi = {
  listMembers: () =>
    APIServices.get<{ success: boolean; data: AdminMember[] }>('/admin/members'),
  listRoles: () => APIServices.get<{ success: boolean; data: AdminRole[] }>('/admin/roles'),
  updateMember: (uid: number, input: UpdateMemberInput) =>
    APIServices.patch<{ success: boolean }>(`/admin/members/${uid}`, input),
  listMachines: () =>
    APIServices.get<{ success: boolean; data: AdminMachine[] }>('/admin/machines'),
  updateMachine: (uid: number, input: UpdateMachineInput) =>
    APIServices.patch<{ success: boolean }>(`/admin/machines/${uid}`, input),
  sensorsSnapshot: () =>
    APIServices.get<{ success: boolean; data: SensorSnapshot[] }>('/admin/sensors'),
};
